<template>

  <div id="texts-wrapper" v-on:click="reloadRandom()">
    <span class="text" v-for="text in randoms">{{text}}</span>

    <!--div class="columns">
      <div class="column is-4">
        <span class="text" v-for="text in deities">{{text}}</span>
      </div>
      <div class="column is-4">
        <span class="text" v-for="text in drugs">{{text}}</span>
      </div>
      <div class="column is-4">
        <span class="text" v-for="text in diseases">{{text}}</span>
      </div>
    </div-->
  </div>

</template>

<script>

/*Vue.component('textitem', {
  template: '<div>hello</div>'
})*/

import axios from 'axios'

function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export default {
  name: 'TextList',
  data() {
    return {
      deities: [],
      drugs: [],
      diseases: [],
      randoms: []
    }
  },
  methods: {
    get(type) {
      axios.get(`/data/${type}.json`).then(res => {
        let texts = res.data.map(v => v.text)
        shuffle(texts)
        this[type] = texts.slice(0, 64)

        this.reloadRandom()
      })
    },
    reloadRandom() {
      let texts = []
      for (let type of ['deities', 'drugs', 'diseases']) {
        texts = texts.concat(this[type])
      }

      shuffle(texts)
      this.randoms = texts.slice(0, 256)
    }
  },
  created() {
    let types = ['deities', 'drugs', 'diseases']
    for (let type of types) {
      this.get(type)
    }
  }
}

</script>
<style scoped>
#texts-wrapper {
  cursor: pointer;
  text-align: center;
}
.text {
  padding-right: 5px;
  word-wrap: break-word;
  user-select: none;
}
.text:nth-child(6n)  {font-size: 120%;}
.text:nth-child(4n)  {opacity:0.8;}
.text:nth-child(12n) {font-size: 140%;}
.text:nth-child(18n) {font-size: 160%;}
.text:nth-child(24n) {font-size: 180%;}

.text {
  box-sizing: border-box;
  transition: all .35s ease;
  position: relative;
}

.text::before,
.text::after {
  content: '';
  height: 14px;
  width: 14px;
  position: absolute;
  transition: all .35s ease;
  opacity: 0;
}

.text::before {
  content: '';
  right: 0;
  top: 0;

  border-top: 1px solid #4E2813;
  border-right: 1px solid #4E2813;
  transform: translate(-100%, 50%);
}

.text:after {
  content: '';
  left: 0;
  bottom: 0;
  border-bottom: 1px solid #4E2813;
  border-left: 1px solid #4E2813;
  transform: translate(100%, -50%);
}

.text:hover:before,
.text:hover:after {
  transform: translate(0,0);
  opacity: 0.3;
}

.text:hover {
  color: #4E2813;
}

</style>
